// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__aW3jE"};